
import { Component, computed, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeedService } from '../../../../core/services/wrench-services/feed.service';
import { FeedWizardComponent } from '../feed-wizard/feed-wizard.component';
import { Feed } from '../../../../core/interfaces/feed.model';
import { ResponseModalComponent } from '../../response-modal/response-modal.component';

@Component({
  selector: 'app-feeds-ui-dialog',
  standalone: true,
  imports: [FormsModule, FeedWizardComponent],
  templateUrl: './feeds-ui-dialog.component.html',
  styleUrl: './feeds-ui-dialog.component.css'
})
export class FeedsUiDialogComponent {

  constructor(public activeModal: NgbActiveModal,
     private feedService: FeedService,
    private modalService: NgbModal,
  ) {}
  @Output() close = new EventEmitter<void>();
  
  searchQuery = signal('');
  feeds = signal<Feed[]>([]);
  showWizard = signal(false);
  
  filteredFeeds = computed(() => {
    const query = this.searchQuery().toLowerCase();
    return this.feeds().filter(feed => 
      feed.getName().toLowerCase().includes(query)
    );
  });
  
  
  ngOnInit(): void {
    this.feedService.feeds$.subscribe(feeds => {
      this.feeds.set(feeds);
    });
  }
  
  onOverlayClick(event: Event): void {
    this.closeDialog();
  }
  
   closeDialog() {
      this.activeModal.dismiss();
  }
  
  focusSearch(): void {
    // Additional focus logic if needed
  }
  
  deleteFeed(index: number): void {
    const feed = this.filteredFeeds()[index];
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    const component = modalRef.componentInstance as ResponseModalComponent;
    component.message = `Are you absolutely sure you want to delete the feed "${feed.getName()}"?`;
    component.showCancel = true;

    modalRef.result.then((result) => {
      if (result === true) {
        this.feedService.deleteFeed(feed.getId());
      }
    }).catch(() => {});
  }
  
  feedChangeState(index: number): void {
    const feed = this.filteredFeeds()[index];
    this.feedService.toggleFeedState(feed.getId());
  }
  
  createNewFeed(): void {
    this.showWizard.set(true);
  }
  
  closeWizard(): void {
    this.showWizard.set(false);
  }
  
  deleteAllFeeds(): void {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    const component = modalRef.componentInstance as ResponseModalComponent;
    component.message = 'Are you sure you want to delete all feeds?';
    component.showCancel = true; // <-- Show Cancel button

    modalRef.result.then((result) => {
      if (result === true) {
        this.feeds().forEach(feed => {
          this.feedService.deleteFeed(feed.getId());
        });
      }
    }).catch(() => {});
  }
}
